import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getCameralAudit,
  getCameralYearsList,
  getCameralAuditForDocumentId,
} from '../../services/API';

import {
  actionTypes,
  requestFailure,
  requestSuccess,
  getYearsFailure,
  getYearsSuccess,
  getDataForDocumentIdSuccess,
  getDataForDocumentIdFailure,
} from './actions';

function* getData(action) {
  const response = yield call(getCameralAudit, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}
function* getYearList() {
  const response = yield call(getCameralYearsList);
  yield put(response.isOk ? getYearsSuccess(response.data) : getYearsFailure(response.error));
}

function* getDataForDocumentId(action) {
  const response = yield call(getCameralAuditForDocumentId, action.payload);
  yield put(
    response.isOk
      ? getDataForDocumentIdSuccess(response.data)
      : getDataForDocumentIdFailure(response.error),
  );
}

export default function* cameralAuditsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.GET_YEARS_START, getYearList);
  yield takeLatest(actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_START, getDataForDocumentId);
}
